export default "__VITE_ASSET__rLEPhj$2__"